// @flow

import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import cx from 'classnames';
import AddMemberButton from 'client/components/member/addMemberButton';
import MemberUtils from 'web-core/src/utils/member';
import type { UserType } from 'web-core/types/user';

import NewMember from './newMember';

type Props = {
  setEditing: Function,
  hasSpouse: boolean,
  fields?: Array<Object> | Object,
  restrictSingle?: boolean,
  user?: UserType | null,
  incompleteMember?: Object | null,
  disableAddMembers?: boolean,
};

const mapStateToProps = state => ({
  user: state.user,
});

class RenderMemberFields extends React.Component<Props> {
  static defaultProps = {
    fields: [],
    restrictSingle: false,
    user: null,
    incompleteMember: null,
    disableAddMembers: false,
  };

  componentDidMount() {
    const { fields, restrictSingle, incompleteMember } = this.props;
    const { primary } = this.getMemberState(fields);

    // Get primary member id from user object to put on primary member
    if (!primary && !restrictSingle) {
      const {
        user: { primaryMemberId },
      } = this.props;
      fields.push({ type: 'primary', selected: true, id: primaryMemberId });
    } else if (incompleteMember) {
      fields.push({ type: incompleteMember.type, selected: true, id: incompleteMember.id });
    }
  }

  getMemberState(fields) {
    const members = fields.getAll();
    const primary = _.find(members, { type: 'primary' });
    const spouse = _.find(members, { type: 'spouse' });

    return {
      primary,
      spouse,
    };
  }

  render() {
    const { fields, restrictSingle, setEditing, hasSpouse, disableAddMembers } = this.props;
    const { spouse } = this.getMemberState(fields);
    const showAddSpouseButton = !spouse && !hasSpouse;

    const renderAddButtons = () => {
      if (fields.length > 0 && restrictSingle) {
        return null;
      }
      return (
        <div style={{ marginTop: '1rem', backgroundColor: 'white' }} className="selection-items">
          {showAddSpouseButton && (
            <AddMemberButton
              type="spouse"
              clickHandler={(e) => {
                e.preventDefault();
                fields.push({ type: 'spouse', selected: true, id: MemberUtils.uuid() });
                setEditing(true);
              }} />
          )}
          <AddMemberButton
            type="dependent"
            clickHandler={(e) => {
              e.preventDefault();
              fields.push({ type: 'dependent', selected: true, id: MemberUtils.uuid() });
              setEditing(true);
            }} />
        </div>
      );
    };

    return (
      <div className={cx('members', { new: !restrictSingle })}>
        {fields.map((member, index) => {
          const memberData = fields.get(index);
          return (
            <div className="member-form" key={member}>
              <NewMember
                member={member}
                memberData={memberData}
                index={index}
                fields={fields}
                setEditing={setEditing} />
            </div>
          );
        })}
        {!disableAddMembers && renderAddButtons()}
      </div>
    );
  }
}

export default connect(mapStateToProps)(RenderMemberFields);
